import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { FootyLivesHerePromoCard } from './FootyLivesHerePromoCard'

export const FootyLivesHerePromoCardRegistration = createRegisterableComponent(
    'footy-lives-here-promo-card',
    () => <FootyLivesHerePromoCard />,
)
